import React from "react";
import { makeStyles } from "@fluentui/react-components";
import { themeTokens } from "../utils/Theming";

const useStyles = makeStyles({
  iconWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0,
    borderRadius: "50%",
    color: "#FFFFFF",
    backgroundColor: themeTokens.colorBrandBackground,
  },
});

const Icon = ({ icon, size = "medium" }: { icon: React.ReactNode; size?: "small" | "medium" | "large" | "extra-large" }) => {
  const styles = useStyles();

  const getSize = (size: string) => {
    switch (size) {
      case "extra-large":
        return "56px";
      case "large":
        return "48px";
      case "medium":
        return "36px";
      case "small":
        return "24px";
      default:
        return "36px";
    }
  };

  const iconSize = getSize(size);

  return (
    <div className={styles.iconWrapper} style={{ width: iconSize, height: iconSize }}>
      {icon}
    </div>
  );
};

export default Icon;